export default "__VITE_ASSET__lO_twjd0__"